import apiService from "./api";
import { sanitizeQueryParams } from "@src/utility/helpers/apiHelper";
import type { TableSortValue } from "@src/shared/constants/sort-order.constants";

export interface GetFeedbackParams {
  page?: number;
  pageSize?: number;
  search?: string;
  entityType?: string;
  rating?: number | string;
  orderBy?: string;
  orderDirection?: TableSortValue;
  [key: string]: unknown;
}

export class FeedbackService {
  async getFeedbacks(query: GetFeedbackParams) {
    return apiService.get("/feedback", {
      params: sanitizeQueryParams(query),
    });
  }

  async getFeedback(id: string | number) {
    return apiService.get(`/feedback/${id}`);
  }
}

export const feedbackService = new FeedbackService();
